<template>
  <b-card
    no-body
    class="shadow-body"
  >
    <b-card-header>
      <b-card-title class="mb-1">
        {{ title }}
      </b-card-title>
    </b-card-header>

    <!-- chart -->
    <b-card-body>
      <chartjs-component-bar-chart
        :height="400"
        :data="dataset"
        :options="chartOptions"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCardTitle,
} from 'bootstrap-vue'
import ChartjsComponentBarChart from './charts-components/ChartjsComponentBarChart.vue'
import chartjsData from './chartjsData'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    ChartjsComponentBarChart,
  },
  props: {
    yearBarChartData: {
      type: [Object, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
    title: {
      type: [String, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: '',
    },
    // Optional y-axis tick formatter (e.g. `v => `$${v}k`` for a report already expressed
    // in $'000) - other pages using this shared chart (CallLogs, Appointments, etc. -
    // plain counts, not currency) leave this unset and keep the default numeric ticks.
    yAxisTickFormatter: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      chartjsData,
      dataset: {},
    }
  },
  computed: {
    chartOptions() {
      const baseOptions = this.chartjsData.latestBarChart.options
      if (!this.yAxisTickFormatter) return baseOptions
      return {
        ...baseOptions,
        scales: {
          ...baseOptions.scales,
          yAxes: baseOptions.scales.yAxes.map(axis => ({
            ...axis,
            ticks: { ...axis.ticks, callback: this.yAxisTickFormatter },
          })),
        },
      }
    },
  },
  watch: {
    yearBarChartData: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$set(this.dataset, 'labels', val.labels)
        this.$set(this.dataset, 'datasets', val.datasets)
      },
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
